"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userProfileLearningProjects = exports.UserProfileLearningProject = void 0;
const tslib_1 = require("tslib");
const zod_1 = tslib_1.__importDefault(require("zod"));
const onboardingExampleDocuments_1 = require("./onboardingExampleDocuments");
exports.UserProfileLearningProject = zod_1.default.object({
    documentUid: zod_1.default.string(),
    title: zod_1.default.string(),
    descriptions: zod_1.default.array(zod_1.default.string()),
    editorView: onboardingExampleDocuments_1.EditorViewSchema,
    imageUrl: zod_1.default.string(),
});
exports.userProfileLearningProjects = [
    {
        documentUid: "816fd949-4e20-408b-b035-f10c45a5853f",
        title: "Schematic",
        descriptions: ["Find and add parts", "Connect your schematic"],
        editorView: onboardingExampleDocuments_1.EditorView.schematic,
        imageUrl: "https://img-cdn.flux.ai/eyJidWNrZXQiOiJncmF2aXRvbi1lbGVjdHJpYy1zeW1ib2xzIiwia2V5IjoiZG9jdW1lbnRfYXNzZXRzL1Byb2plY3QtVGh1bWJuYWlsLWYyMjA5ZDVmLWY3ZGItNGYyYS1hZWU2LTc5YjU2MzJmZjZmZi5wbmciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjEyOCwiaGVpZ2h0IjoxMjgsImZpdCI6ImNvbnRhaW4iLCJiYWNrZ3JvdW5kIjp7InIiOjAsImciOjAsImIiOjAsImFscGhhIjowfX19LCJvdXRwdXRGb3JtYXQiOiJ3ZWJwIn0=",
    },
    {
        documentUid: "1a7752ac-7b5e-4967-9e39-88cf61641150",
        title: "PCB",
        descriptions: ["Position and rotate components", "Draw traces"],
        editorView: onboardingExampleDocuments_1.EditorView.pcb,
        imageUrl: "https://img-cdn.flux.ai/eyJidWNrZXQiOiJncmF2aXRvbi1lbGVjdHJpYy1zeW1ib2xzIiwia2V5IjoiZG9jdW1lbnRfYXNzZXRzL2ltYWdlLWI3NDkyODk1LTU1N2YtNDdhNi1hMWZhLTQ4NWUyNWNkYjk5Yy5wbmciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjEyOCwiaGVpZ2h0IjoxMjgsImZpdCI6ImNvbnRhaW4iLCJiYWNrZ3JvdW5kIjp7InIiOjAsImciOjAsImIiOjAsImFscGhhIjowfX19LCJvdXRwdXRGb3JtYXQiOiJ3ZWJwIn0=",
    },
    {
        documentUid: "f7822bb1-8325-4373-9639-2a0a7f072926",
        title: "PCB – Advanced",
        descriptions: ["Configure the stackup", "Move across layers", "Create vias"],
        editorView: onboardingExampleDocuments_1.EditorView.pcb,
        imageUrl: "https://img-cdn.flux.ai/eyJidWNrZXQiOiJncmF2aXRvbi1lbGVjdHJpYy1zeW1ib2xzIiwia2V5IjoiZG9jdW1lbnRfYXNzZXRzL2ltYWdlLS0xLS00ZjJhMjFlYi03Njc5LTQ5MjctYjA2MC1hMzkwZTQ3NzdkNGIucG5nIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoxMjgsImhlaWdodCI6MTI4LCJmaXQiOiJjb250YWluIiwiYmFja2dyb3VuZCI6eyJyIjowLCJnIjowLCJiIjowLCJhbHBoYSI6MH19fSwib3V0cHV0Zm9ybWF0Ijoid2VicCJ9",
    },
    {
        documentUid: "b121e773-3b90-468b-b635-33b5a5c200d5",
        title: "Auto-Layout",
        descriptions: ["Route your nets with AI", "One-click automation"],
        editorView: onboardingExampleDocuments_1.EditorView.pcb_2d,
        imageUrl: "/assets/profile-education/auto-layout-nux-image.png",
    },
    // TODO: HIDE FOR LAUNCH
    // {
    //     documentUid: "de9f7751-a2e3-469e-a292-ed336a0a5e4e",
    //     title: "Manufacture",
    //     descriptions: ["AI Auto-Layout", "Review and export your design"],
    //     imageUrl:
    //         "https://img-cdn.flux.ai/eyJidWNrZXQiOiJncmF2aXRvbi1lbGVjdHJpYy1zeW1ib2xzIiwia2V5IjoiZG9jdW1lbnRfYXNzZXRzL2EtY2lyY3VpdC1zY2hlbWF0aWMtb24tYS1ibGFjay1iYWNrZ3JvdW5kLWUxZjI4YjFkLTBjNjItNDRlNS04YjlkLWM0NDhmMjE0MTA0ZS5wbmciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjEyOCwiaGVpZ2h0IjoxMjgsImZpdCI6ImNvbnRhaW4iLCJiYWNrZ3JvdW5kIjp7InIiOjAsImciOjAsImIiOjAsImFscGhhIjowfX19LCJvdXRwdXRGb3JtYXQiOiJ3ZWJwIn0=",
    // },
    {
        documentUid: "",
        title: "Book a Call",
        descriptions: ["The quickest way to start", "1:1 guidance with an expert", "Tailored to your needs"],
        editorView: onboardingExampleDocuments_1.EditorView.pcb,
        imageUrl: "",
    },
    {
        documentUid: "",
        title: "Join Slack Community",
        descriptions: ["Meet hardware engineers", "Get questions answered", "Find inspiration"],
        editorView: onboardingExampleDocuments_1.EditorView.pcb,
        imageUrl: "",
    },
];
//# sourceMappingURL=userProfileLearningProjects.js.map